import React, { useState } from 'react';
import styles from './InstallModal.module.scss';

const BASE_URL     = 'https://security.ncore.kg/static/ncore-cli';
const INSTALL_URL  = `${BASE_URL}/install.ps1`;
const INSTALL_SH   = `${BASE_URL}/install.sh`;
const NCORE_JS_URL = `${BASE_URL}/bin/ncore.js`;

function CopyBlock({ value }) {
    const [copied, setCopied] = useState(false);
    function handle() {
        navigator.clipboard.writeText(value).catch(() => {});
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }
    return (
        <div className={styles.codeBlock}>
            <pre className={styles.code}>{value}</pre>
            <button className={styles.copyBtn} onClick={handle} title="Скопировать">
                {copied ? (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#10b981' }}>
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                ) : (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
                    </svg>
                )}
            </button>
        </div>
    );
}

const STEPS_WIN = [
    {
        num: 1,
        title: 'Скачай и запусти установщик',
        body: 'Открой PowerShell от имени администратора и выполни команду:',
        code: `irm ${INSTALL_URL} | iex`,
    },
    {
        num: 2,
        title: 'Или скачай вручную',
        body: 'Скачай install.ps1 и запусти в PowerShell:',
        code: `Set-ExecutionPolicy RemoteSigned -Scope CurrentUser\n.\\install.ps1`,
    },
    {
        num: 3,
        title: 'Проверь установку',
        body: 'Перезапусти терминал и выполни:',
        code: `ncore --version`,
    },
];

const STEPS_MAC = [
    {
        num: 1,
        title: 'Установи Node.js (если нет)',
        body: 'Через Homebrew:',
        code: `brew install node`,
    },
    {
        num: 2,
        title: 'Запусти установщик',
        body: 'В терминале:',
        code: `curl -fsSL ${INSTALL_SH} | bash`,
    },
    {
        num: 3,
        title: 'Перезапусти терминал и проверь',
        body: '',
        code: `ncore --version`,
    },
];

const STEPS_LINUX = [
    {
        num: 1,
        title: 'Установи Node.js (если нет)',
        body: 'Ubuntu/Debian:',
        code: `curl -fsSL https://deb.nodesource.com/setup_lts.x | sudo -E bash -\nsudo apt-get install -y nodejs`,
    },
    {
        num: 2,
        title: 'Запусти установщик',
        body: '',
        code: `curl -fsSL ${INSTALL_SH} | bash`,
    },
    {
        num: 3,
        title: 'Проверь установку',
        body: '',
        code: `ncore --version`,
    },
];

const STEPS_MANUAL = [
    {
        num: 1,
        title: 'Скачай ncore.js напрямую',
        body: 'Требуется Node.js 16+',
        code: `curl -fsSL ${NCORE_JS_URL} -o ncore.js`,
    },
    {
        num: 2,
        title: 'Запусти через node',
        body: 'Или добавь в PATH как ncore',
        code: `node ncore.js help`,
    },
];

const TABS = [
    { key: 'windows', label: 'Windows', icon: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/></svg>
    )},
    { key: 'mac', label: 'macOS', icon: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
    )},
    { key: 'linux', label: 'Linux', icon: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12.504 0c-.155 0-.315.008-.48.021C7.576.336 3.58 3.08 1.65 7.258a11.57 11.57 0 00-.978 4.29C.521 15.082 2.278 18.41 5.17 20.6c.5.378 1.003.71 1.51 1.006-.023-.024-.045-.05-.068-.073a8.1 8.1 0 01-1.64-2.278 8.055 8.055 0 01-.75-3.328c0-4.461 3.627-8.085 8.091-8.085s8.091 3.624 8.091 8.085c0 1.182-.254 2.303-.716 3.328a8.1 8.1 0 01-1.64 2.278c-.023.024-.045.05-.068.073.507-.296 1.01-.628 1.51-1.006 2.892-2.19 4.649-5.518 4.498-9.052a11.57 11.57 0 00-.978-4.29C21.08 3.08 17.084.336 12.984.021A8.1 8.1 0 0012.504 0z"/></svg>
    )},
    { key: 'manual', label: 'Вручную', icon: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
    )},
];

const STEPS_MAP = { windows: STEPS_WIN, mac: STEPS_MAC, linux: STEPS_LINUX, manual: STEPS_MANUAL };

export default function InstallModal({ onClose }) {
    const [tab, setTab] = useState('windows');

    return (
        <div className={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
            <div className={styles.modal}>
                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.headerLeft}>
                        <div className={styles.headerIcon}>
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ color: '#c084fc' }}>
                                <rect x="2" y="3" width="20" height="14" rx="2"/>
                                <line x1="8" y1="21" x2="16" y2="21"/>
                                <line x1="12" y1="17" x2="12" y2="21"/>
                                <polyline points="8 10 11 13 16 8"/>
                            </svg>
                        </div>
                        <div>
                            <h2 className={styles.title}>Установка ncore CLI</h2>
                            <p className={styles.sub}>Командная утилита для работы с NcoreHub</p>
                        </div>
                    </div>
                    <button className={styles.closeBtn} onClick={onClose}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>

                {/* Download button */}
                <div className={styles.downloadBox}>
                    {tab === 'windows' && (
                        <>
                        <a href={INSTALL_URL} download="install.ps1" className={styles.downloadBtn}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                                <polyline points="7 10 12 15 17 10"/>
                                <line x1="12" y1="15" x2="12" y2="3"/>
                            </svg>
                            Скачать install.ps1
                        </a>
                        <span className={styles.downloadNote}>Windows · PowerShell · Node.js 16+</span>
                        </>
                    )}
                    {(tab === 'mac' || tab === 'linux') && (
                        <>
                        <a href={INSTALL_SH} download="install.sh" className={styles.downloadBtn}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                                <polyline points="7 10 12 15 17 10"/>
                                <line x1="12" y1="15" x2="12" y2="3"/>
                            </svg>
                            Скачать install.sh
                        </a>
                        <span className={styles.downloadNote}>{tab === 'mac' ? 'macOS' : 'Linux'} · Bash · Node.js 16+</span>
                        </>
                    )}
                    {tab === 'manual' && (
                        <>
                        <a href={NCORE_JS_URL} download="ncore.js" className={styles.downloadBtn}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                                <polyline points="7 10 12 15 17 10"/>
                                <line x1="12" y1="15" x2="12" y2="3"/>
                            </svg>
                            Скачать ncore.js
                        </a>
                        <span className={styles.downloadNote}>Любая ОС · Node.js 16+</span>
                        </>
                    )}
                </div>

                {/* Tabs */}
                <div className={styles.tabs}>
                    {TABS.map(t => (
                        <button
                            key={t.key}
                            className={t.key === tab ? styles.tabActive : styles.tabBtn}
                            onClick={() => setTab(t.key)}
                        >
                            {t.icon} {t.label}
                        </button>
                    ))}
                </div>

                {/* Steps */}
                <div className={styles.steps}>
                    {(STEPS_MAP[tab] || STEPS_WIN).map(s => (
                        <div key={s.num} className={styles.step}>
                            <div className={styles.stepNum}>{s.num}</div>
                            <div className={styles.stepBody}>
                                <div className={styles.stepTitle}>{s.title}</div>
                                {s.body && <p className={styles.stepDesc}>{s.body}</p>}
                                <CopyBlock value={s.code} />
                            </div>
                        </div>
                    ))}
                </div>

                {/* Commands reference */}
                <div className={styles.cmdsSection}>
                    <div className={styles.cmdsTitle}>Основные команды</div>
                    <div className={styles.cmdsGrid}>
                        {[
                            ['ncore init',                    'Инициализировать репозиторий'],
                            ['ncore clone <url>',             'Клонировать репозиторий'],
                            ['ncore add .',                   'Добавить все изменения'],
                            ['ncore commit -m "сообщение"',   'Зафиксировать коммит'],
                            ['ncore push origin main',        'Отправить на сервер'],
                            ['ncore pull',                    'Получить изменения'],
                            ['ncore branch',                  'Список веток'],
                            ['ncore status',                  'Статус рабочей директории'],
                        ].map(([cmd, desc]) => (
                            <div key={cmd} className={styles.cmdRow}>
                                <code className={styles.cmdCode}>{cmd}</code>
                                <span className={styles.cmdDesc}>{desc}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
